import Element from './Element';
import GameObject from '../../GameObject/GameObject';

export default class BackCardItem extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            name: `backcard_${params.id}`,
            ...params,
        });
    }

    protected onCreate(params: any): void {
        super.onCreate(params);

        // Unlocked.
        if (params.unlocked) {
            const backcard: Element = GameObject.Instantiate(Element, {
                type: 'group',
                name: 'unlocked',
                layout: {
                    anchors: [0.5, 0.55, 0.5, 0.55],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                    constrains: {
                        heightMin: 202,
                        heightMax: 202,
                        widthMin: 144,
                        widthMax: 144,
                    },
                },
                components: [
                    {
                        type: 'image',
                        data: {},
                    },
                ],
                children: [
                    {
                        type: 'group',
                        name: 'highlight',
                        layout: {
                            anchors: [0.5, 0.48, 0.5, 0.48],
                            pivot: [0.5, 0.5],
                            offsets: [0, 0, -24, -28],
                        },
                        components: [
                            {
                                type: 'image',
                                data: {
                                    cacheKey: 'backcards_select',
                                },
                            },
                            {
                                type: 'visibility',
                                data: {
                                    hidden: true,
                                },
                            },
                        ],
                    },
                ],
            });
            this.addChild(backcard);
        } else {
            // Locked.
            const locked: Element = GameObject.Instantiate(Element, {
                type: 'group',
                name: 'locked',
                layout: {
                    anchors: [0.5, 0.55, 0.5, 0.55],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                    constrains: {
                        heightMin: 202,
                        heightMax: 202,
                        widthMin: 144,
                        widthMax: 144,
                    },
                },
                components: [
                    {
                        type: 'image',
                        data: {
                            cacheKey: 'backcard_close',
                        },
                    },
                ],
            });
            this.addChild(locked);

            const id = params.id;
            if (id === 4 || id === 5 || id === 6) {
                const requiredStars = id === 4 ? '30' : id === 5 ? '75' : '115';
                const starPanel: Element = GameObject.Instantiate(Element, {
                    type: 'group',
                    name: 'stars_panel',
                    layout: {
                        anchors: [0.5, 1, 0.5, 1],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        constrains: {
                            heightMin: 51,
                            heightMax: 51,
                            widthMin: 126,
                            widthMax: 126,
                        },
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'stars_panel',
                            },
                        },
                    ],
                    children: [
                        {
                            type: 'group',
                            name: 'text',
                            layout: {
                                anchors: [0.5, 0.5, 0.5, 0.5],
                                pivot: [0.5, 0.5],
                                offsets: [-12, 1, 0, 0],
                            },
                            components: [
                                {
                                    type: 'text',
                                    data: {
                                        textLocalizationKey: requiredStars,
                                        style: {
                                            font: 'RussoOne',
                                            fill: '#512415',
                                            fontSize: '28px',
                                        },
                                        align: 'center',
                                    },
                                },
                            ],
                        },
                    ],
                });
                locked.addChild(starPanel);
            } else {
                const chest: Element = GameObject.Instantiate(Element, {
                    type: 'group',
                    name: 'chest',
                    layout: {
                        anchors: [0.5, 1, 0.5, 1],
                        pivot: [0.5, 0.5],
                        offsets: [0, 0, 0, 0],
                        constrains: {
                            heightMin: 68,
                            heightMax: 68,
                            widthMin: 68,
                            widthMax: 68,
                        },
                    },
                    components: [
                        {
                            type: 'image',
                            data: {
                                cacheKey: 'chest_close',
                            },
                        },
                    ],
                });
                locked.addChild(chest);
            }
        }
    }
}
